import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "next-i18next";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ShareIcon from "@mui/icons-material/Share";

import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TelegramShareButton,
  TelegramIcon,
} from "react-share";
import { Grid, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Button, { ButtonVariant } from "../button/button";
import { useRouter } from "next/router";
import Heading1 from "../typo/heading1/heading1";
import Paragraph from "../typo/paragraph/paragraph";
import breakpoints from "../../helpers/breakpoints";

const Root = styled.div``;

const IconsOuter = styled.div`
  display: flex;
  justify-content: space-between;
  @media (min-width: ${breakpoints.min.md}) {
    justify-content: flex-start;
    button {
      margin-right: 8px;
    }
  }
`;

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  maxWidth: "80%",
  bgcolor: "white",
  boxShadow: 24,
  p: 4,
};

const Sharer: React.FC = () => {
  const router = useRouter();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [copiedToClipboard, setCopiedToClipboard] = React.useState(false);
  const [url, setUrl] = React.useState<string | undefined>(undefined);
  const { t } = useTranslation();
  const toggleModal = () => {
    setModalOpen((prev) => !prev);
  };
  const title = "";
  const iconProps = {
    size: 48,
    round: true,
  };

  const handleCopyToClipboard = () => {
    if (url) {
      navigator.clipboard.writeText(url);
      setCopiedToClipboard(true);
      setTimeout(() => {
        setCopiedToClipboard(false);
      }, 1000);
    }
  };

  React.useEffect(() => {
    setUrl(window.location.href);
  }, [router.asPath]);

  if (url === undefined) {
    return null;
  }

  return (
    <>
      <Root>
        <Button handleClick={toggleModal} variant={ButtonVariant.primary}>
          <ShareIcon /> {t("sharer.shareIt")}
        </Button>
      </Root>
      <Modal open={modalOpen} onClose={toggleModal}>
        <Box sx={style}>
          <Heading1 large={true}>{t("sharer.title")}</Heading1>
          <Box mt={3} />
          <Paragraph>{t("sharer.shareThisLinkVia")}</Paragraph>
          <IconsOuter>
            <FacebookShareButton title={title} url={url}>
              <FacebookIcon {...iconProps} />
            </FacebookShareButton>
            <TwitterShareButton title={title} url={url}>
              <TwitterIcon {...iconProps} />
            </TwitterShareButton>
            <LinkedinShareButton title={title} url={url}>
              <LinkedinIcon {...iconProps} />
            </LinkedinShareButton>
            <WhatsappShareButton title={title} url={url}>
              <WhatsappIcon {...iconProps} />
            </WhatsappShareButton>
            <TelegramShareButton title={title} url={url}>
              <TelegramIcon {...iconProps} />
            </TelegramShareButton>
          </IconsOuter>
          <Box mt={2} />
          <Paragraph>{t("sharer.orCopyLink")}</Paragraph>
          <Box display="flex">
            <Button
              handleClick={handleCopyToClipboard}
              variant={ButtonVariant.primary}
            >
              {copiedToClipboard ? t("sharer.copied") : t("sharer.copy")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Sharer;
